/* ============================================================
   Hero Slideshow JS (hero-slideshow.liquid)
   ============================================================ */
(function () {
  'use strict';

  function initHeroSlider(slider) {
    const track  = qs('.js-hero-track', slider);
    const slides = qsa('.hero-slide', slider);
    const dots   = qsa('.hero-slideshow__dot', slider);
    const prevBtn = qs('.js-hero-prev', slider);
    const nextBtn = qs('.js-hero-next', slider);
    if (!track || slides.length < 2) return;

    let current  = 0;
    let interval;

    function goTo(idx, auto) {
      slides[current].classList.remove('hero-slide--active');
      dots[current]?.classList.remove('hero-slideshow__dot--active');
      dots[current]?.setAttribute('aria-selected', 'false');

      current = (idx + slides.length) % slides.length;

      slides[current].classList.add('hero-slide--active');
      dots[current]?.classList.add('hero-slideshow__dot--active');
      dots[current]?.setAttribute('aria-selected', 'true');

      track.style.transform = `translateX(-${current * 100}%)`;

      if (auto) document.dispatchEvent(new CustomEvent('heroSlide', { detail: { index: current } }));
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); resetInterval(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); resetInterval(); });
    dots.forEach((dot, i) => { dot.addEventListener('click', () => { goTo(i); resetInterval(); }); });

    /* Keep the theme editor preview on the slide being edited. */
    slider.addEventListener('shopify:block:select', event => {
      const selectedSlide = event.target.closest('.hero-slide');
      const selectedIndex = slides.indexOf(selectedSlide);
      if (selectedIndex >= 0) {
        clearInterval(interval);
        goTo(selectedIndex);
      }
    });

    function resetInterval() {
      clearInterval(interval);
      if (window.Shopify && Shopify.designMode) return;
      interval = setInterval(() => goTo(current + 1, true), 6000);
    }

    resetInterval();

    slider.addEventListener('mouseenter', () => clearInterval(interval));
    slider.addEventListener('mouseleave', () => resetInterval());

    /* Touch swipe */
    let touchX = 0;
    slider.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', e => {
      const diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { goTo(diff > 0 ? current + 1 : current - 1); resetInterval(); }
    });
  }

  document.querySelectorAll('.hero-slideshow').forEach(initHeroSlider);
})();
